import {Component, Inject, OnInit, Optional} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { MainProvider } from 'src/app/providers/mian.provider';
import { MasterProvider } from 'src/app/providers/master.provider';
import {ToastrService} from "ngx-toastr";
import { MaterialModule } from 'src/app/material.module';
import { Router,ActivatedRoute } from '@angular/router';
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatNativeDateModule} from "@angular/material/core";
import { CommonModule } from '@angular/common';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MatIconModule } from '@angular/material/icon';
import { MatFormField } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { provideNativeDateAdapter } from '@angular/material/core';
import { AsyncPipe, DatePipe, NgForOf } from '@angular/common';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-update-admin-password',
  standalone: true,
  imports: [
      MatFormField,
      MaterialModule,
      FormsModule,
      MatDatepickerModule,
      MatNativeDateModule,
      CommonModule,
      TablerIconsModule,
      MatIconModule,
      MatInputModule
  ],
    providers: [MasterProvider, MainProvider, DatePipe, provideNativeDateAdapter()],
  templateUrl: './update-admin-password.component.html',
  styleUrl: './update-admin-password.component.scss'
})
export class UpdateAdminPasswordComponent {

  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
  admindata: any = {};
  hidePassword: boolean = true;
  hideNewPassword: boolean = true;
  hideConfirmPassword: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<UpdateAdminPasswordComponent>,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private mainProvider: MainProvider,
    private masterProvider: MasterProvider,
    public router: Router,
    private route: ActivatedRoute,
    private toaster: ToastrService,
    private datePipe: DatePipe,
    public userService: UserService,
  ) {
  }

  ngOnInit() {
  }

  Submit(): void {
    let userObj = JSON.parse(localStorage.getItem('WD-TOKEN'));

    if(this.oldPassword !== userObj.user_password) {
      this.toaster.error('Wrong Old Passwprd!');
      return;
    }

    if(this.confirmPassword !== this.newPassword) {
      this.toaster.warning('Confirm Password not match with New Passwod!')
      return;
    }

    const payload = {
      user_id: userObj.user_id,
      user_access_token: userObj.user_access_token,
      public_key: environment.public_key,
      user_old_password: this.oldPassword,
      user_new_password: this.newPassword,
      user_confirm_password: this.confirmPassword
    }

    // console.log(payload);
    // return;

      this.mainProvider.appUserUpdatePassword(payload).subscribe(resp => {
        if (resp.responseCode === 200) {
          this.toaster.success('Password Updated Successfully!');
          this.dialogRef.close({event: true});
        } else {
          this.toaster.error(resp.responseMessage);
        }
      }, error => {
        this.toaster.error('Something went wrong, Please try again later!');
      });
  }


  closeDialog(): void {
    this.dialogRef.close();
  }

}
